import type { Flag } from '#utils/flags/records/Flag';

import { useCheckAccessForFlagInCurrentEnvironment } from './useCheckAccessForFlagInCurrentEnvironment';

export function usePendingChangesAccessDecisions(flag: Flag) {
  const checkAccess = useCheckAccessForFlagInCurrentEnvironment(flag);
  return {
    createApprovalRequest: checkAccess('createApprovalRequest'),
    updateScheduledChanges: checkAccess('updateScheduledChanges'),
  } as const;
}
